import { defineComponent } from "vue";

export interface IMultiSelectDropDownOption {
    [groupText: string]: IMultiSelectOption[];
}

export interface IMultiSelectOption {
    displayText: string;
    value: any;
    application?: number;
    disabled?: boolean;
}

export default defineComponent({
    props: {
        labelText: {
            type: String,
            default: ""
        },
        dropDownOptions: {
            type: Object,
            default: {}
        },
        selectedOptions: {
            type: Array,
            default: []
        },
        resetToSelectAllProp: {
            type: Boolean,
            default: false
        },
        disabled: { type: Boolean, default: false },
        classes: { type: String, default: null }
    },

    data() {
        return {
            filteredOptions: {} as IMultiSelectDropDownOption,
            filteredOptionsValues: {} as { [key: string]: any },
            search: "" as string,
            selectedOptionsCopy: {},
            allOptions: []
        };
    },

    emits: ["updateBranches"],

    mounted() {
        this.filteredOptions = { ...this.dropDownOptions };
        $(this.$refs.dropDownMenu).on("click", (e) => {
            e.stopPropagation();
        });
        $(this.$refs.dropDownElement).on("shown.bs.dropdown", (e) => {
            (this.$refs.searchInput as HTMLInputElement)?.focus();
        });
    },

    watch: {
        search: function () {
            if (!!this.search) {
                for (let groupName of Object.keys(this.dropDownOptions)) {
                    let options = this.dropDownOptions[groupName];
                    this.filteredOptions[groupName] = options.filter((option: any) =>
                        option.displayText.toLowerCase().includes(this.search.toLowerCase())
                    );
                }
            } else {
                this.filteredOptions = { ...this.dropDownOptions };
            }
        },
        filteredOptions() {
            Object.keys(this.filteredOptions).forEach((key) => {
                this.filteredOptionsValues[key] = this.filteredOptions[key].map((item) => item.value);
            });
        },
        resetToSelectAllProp() {
            this.allOptions.splice(0, this.allOptions.length);
            for (let groupName of Object.keys(this.dropDownOptions)) {
                this.selectAllGroupOptions(groupName);
            }
        }
    },

    computed: {
        getbuttonText(): string {
            if (this.selectedOptions.length === this.getdropDownOptionsLength) {
                return this.labelText ? `${this.labelText}: All` : "All Selected";
            } else if (this.selectedOptions.length === 0) {
                return `None selected`;
            } else {
                const selectedTextSuffix = `${this.selectedOptions.length} selected`;
                return this.labelText ? `${this.labelText}: ${selectedTextSuffix}` : selectedTextSuffix;
            }
        },

        getsearchPlaceholder(): string {
            return `Search for ${this.labelText}`;
        },

        getdropDownOptionsLength() {
            if (this.dropDownOptions) {
                this.filteredOptions = { ...this.dropDownOptions };
                return Object.values(this.dropDownOptions).reduce(
                    (len, options) => options.filter((option) => !option.disabled).length + len,
                    0
                );
            }
        }
    },

    methods: {
        toggleAllSelected() {
            if (this.getdropDownOptionsLength === this.selectedOptions.length) {
                this.$emit("updateBranches", []);
            } else {
                this.allOptions.splice(0, this.allOptions.length);
                for (let groupName of Object.keys(this.dropDownOptions)) {
                    this.selectAllGroupOptions(groupName);
                }
            }
        },

        closeDropDown() {
            $(this.$refs.dropDownElement).dropdown("toggle");
        },

        toggleAllGroupOptions(groupName: string) {
            let options = [...this.selectedOptions];
            const enabledOptions = this.dropDownOptions[groupName]
                .filter((option) => !option.disabled)
                .map((option) => option.value);
            if (this.allGroupElementsSelected(groupName)) {
                options = options.filter((item) => !enabledOptions.includes(item));
            } else {
                options = [...new Set([...options, ...enabledOptions])];
            }
            this.$emit("updateBranches", options);
        },

        allGroupElementsSelected(groupName: string) {
            const isAllIn = this.filteredOptionsValues[groupName]?.every((branchId: string) => {
                return this.selectedOptions.includes(branchId);
            });
            return isAllIn;
        },

        toggleSingleSelection(branchId: any) {
            const option = Object.values(this.dropDownOptions)
                .flat()
                .find((item) => item.value === branchId);
            if (option?.disabled) {
                return;
            }
            let options = [...this.selectedOptions];
            if (options.includes(branchId)) {
                options = options.filter((item) => item != branchId);
            } else {
                options.push(branchId);
            }
            this.$emit("updateBranches", options);
        },

        selectAllGroupOptions(groupName: string) {
            for (let option of this.dropDownOptions[groupName]) {
                if (!option.disabled) {
                    this.allOptions.push(option.value);
                }
            }
            this.$emit("updateBranches", this.allOptions);
        }
    }
});
